import { Box, Text } from '@medely/ui-kit';
import React, { ReactElement } from 'react';
import DisplayHelpers from '../../utils/displayHelpers';
import { MedelyDateTime } from '@medely/date-time-tools';
import { CountdownBadge } from './CountdownBadge';
import { JobDetailsFragment } from './jobDetailsComponents/graphql';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';

type ShiftDateProps = {
  job?: FragmentType<typeof JobDetailsFragment> | null;
  displayHours?: boolean;
  displayStartingSoonBadge?: boolean;
};

export const ShiftDate = ({
  job: inputJob,
  displayHours = false,
  displayStartingSoonBadge = false,
}: ShiftDateProps): ReactElement => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const date = new MedelyDateTime(job?.starts_date, {
    tz: job?.location?.timezone_lookup ?? 'America/Los_Angeles',
    keepLocalTime: true,
  }).humanizedDate;
  const hours = DisplayHelpers.job.time({
    current_starts_time: job?.current_starts_time,
    current_ends_time: job?.current_ends_time,
    approved_clock_in: job?.approved_clock_in,
    approved_clock_out: job?.approved_clock_out,
    guaranteed_minimum_hours: job?.guaranteed_minimum_hours,
    status: job?.status,
    shift_type: job?.shift_type,
    assignment: job?.assignment,
    location: job?.location,
    options: {
      scheduledShiftStyle: true,
    },
  });
  return (
    <Box testId="shift-date">
      <Text size="m">{`${date} ${displayHours && hours ? ` • ${hours}` : ``}`}</Text>
      <>
        {displayStartingSoonBadge && (
          <Box pt={0.5}>
            <CountdownBadge
              currentStartsTime={job?.current_starts_time}
              timezone={job?.location?.timezone_lookup}
            />
          </Box>
        )}
      </>
    </Box>
  );
};
